module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch4_20210921010834_T.0cbaf85a.jpg";